<template>
  <el-radio-group v-model="localJumpType" @change="localJumpTo = ''" v-removeAriaHidden>
    <div class="radio-row">
      <el-radio :label="1">小程序appid</el-radio>
      <el-input v-if="localJumpType === 1" v-model="localJumpTo"></el-input>
      <el-input v-else disabled></el-input>
    </div>
    <div class="radio-tips">
      跳转其他小程序，需填写它的appid
      <span @click="showAppidInfo">如何获取？</span>
    </div>
    <div class="radio-row">
      <el-radio :label="2">公众号文章</el-radio>
      <el-input v-if="localJumpType === 2" v-model="localJumpTo"></el-input>
      <el-input v-else disabled></el-input>
    </div>
    <div class="radio-tips">
      跳转微信公众号文章，需填写文章链接
      <span @click="openUrl">如何获取？</span>
    </div>
    <div class="radio-row">
      <el-radio :label="5">线路班次</el-radio>
      <el-select v-model="localJumpTo" placeholder="请选择线路" v-if="localJumpType === 5" filterable clearable>
        <el-option v-for="item in lineList" :key="item.id" :label="item.lineName" :value="item.id"></el-option>
      </el-select>
      <el-select placeholder="请选择线路" :value="''" v-else disabled> </el-select>
    </div>
    <div class="radio-tips">
      点击广告后将查询该条线路班次信息
    </div>
    
    <div class="radio-row">
      <el-radio :label="3">旅游包车页面</el-radio>
    </div>
    <div class="radio-row" v-if="hasActivity">
      <el-radio :label="6">营销活动页面</el-radio>
      <el-select v-model="localJumpTo" placeholder="请选择活动" v-if="localJumpType ===6" filterable clearable>
        <el-option v-for="item in activityList" :key="item.id" :label="`（${item.code}）${item.name}`" :value="item.id + ''"></el-option>
      </el-select>
      <el-select placeholder="请选择活动" :value="''" v-else disabled> </el-select>
    </div>
    <div class="radio-row">
      <el-radio :label="4">不跳转</el-radio>
    </div>
  </el-radio-group>
</template>

<script>
export default {
  name: 'JumpTypeSelector',
  props: ['jumpType', 'jumpTo', 'hasActivity'],
  data() {
    return {
      localJumpType: this.jumpType,
      localJumpTo: this.jumpTo,
      lineList: [],
      activityList: []
    };
  },
  watch: {
    jumpType(newVal) {
      this.localJumpType = newVal;
    },
    jumpTo(newVal) {
      if (this.jumpType == 5) {
        this.localJumpTo = newVal ? JSON.parse(newVal).id : newVal;
      } else {
        this.localJumpTo = newVal;
      }
    },
    localJumpType(newVal) {
      this.$emit('update:jumpType', newVal);
    },
    localJumpTo(newVal) {
      console.log('newVal::: ', newVal, this.jumpTo);
      if (this.jumpType == 5 && newVal) {
        let cItem = this.lineList.find(item => item.id == newVal)
        this.$emit('update:jumpTo', cItem ? JSON.stringify({
          id: newVal,
          name: `${cItem?.startStationName}-${cItem?.endStationName}`
        }): this.jumpTo);
      }else {
        this.$emit('update:jumpTo', newVal);
      }
    }
  },
  created() {
    this.getLineList()
    this.getActivityList()
  },
  methods: {
    async getActivityList() {
      let url = '/api/v1/manage/activity/list'
      let { code, data } = await this.$axios.get(url)
      if (code == 1) {
        this.activityList = data
      }
    },
    showAppidInfo() {
      this.$emit('show-appid-info');
    },
    openUrl() {
      const externalLinks = require('@/assets/json/externalLinks').default
      window.open(externalLinks.docs.bannerJumpType)
    },
    async getLineList() {
      let url = '/api/v1/manage/line/recommend/line'
      let { code, data } = await this.$axios.get(url)
      if (code == 1) {
        this.lineList = data.map(item => {
          return {
            ...item,
            lineName: `${item.startStationName}-${item.endStationName}`
          }
        })
      }
    }
  }
};
</script>

<style lang="less" scoped>
.radio-row {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .el-radio {
    flex-shrink: 0;
    width: 120px
  }
}

.radio-tips {
  margin: 0 0 20px 150px;
  font-size: 10px;

  span {
    color: #66b1ff;
    cursor: pointer;
  }
}
</style>